module.exports = __webpack_public_path__ + "img/resources-tasks.27424216.png";